import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "paneContainer", "nav"]

  connect() {
    // Everything directly under the paneContainer with a data-pane-id is a pane
    this.panes = this.paneContainerTarget.querySelectorAll("& > [data-pane-id]")
    this.activePaneId = null

    // Intermediary data structures for lookups by ID
    this.panesById = Array.from(this.panes).reduce((byId, pane) => ({ ...byId, [pane.dataset.paneId]: pane }), {})
    this.allPaneIds = Object.keys(this.panesById)

    // Mise en place
    this.updateTo(this.defaultValue())
  }

  defaultValue() {
    if(this.hasSelectTarget && this.allPaneIds.includes(this.selectTarget.value)) {
      return this.selectTarget.value
    } else {
      return this.allPaneIds[0]
    }
  }

  // Utility methods for direct use in actions
  onChange(e) { this.updateTo(e.target.value) }
  onClick(e) { this.updateTo(e.target.dataset.name) }

  pushState(e) {
    const url = new URL(window.location.href.split("/").slice(0, -1).concat(e.target.value).join("/"))
    window.history.pushState({}, "", url)
  }

  updateTo(id) {
    if(!this.allPaneIds.includes(id))
      return

    // Disable every pane
    this.panes.forEach(element => element.style.display = "none")

    // Enable the right pane
    this.panesById[id].style.display = "initial"
    this.activePaneId = id

    // If this is a clicky-type nav, rather than a select nav, handle the highlighting of the appropriate tabs
    if(this.hasNavTarget) {
      const clickTargets = Array.from(this.navTarget.querySelectorAll("& > [data-name]"))
      clickTargets.forEach(target => target.classList.remove("active"))
      clickTargets.find(target => target.dataset.name === this.activePaneId).classList.add("active")
    }
  }
}
